import { crabDevice } from '@hfzq/crab-utils';
import { AppCache, LocalCacheStorage, SessionStorageCache } from '@src/helper/local-cache-storage';
import { Mutex } from '@src/helper/mutex';
import { xfnRequest } from '../helper/request-token';

type CommonConfig = {
  // 接口请求地址
  FUNDLINK: string;
  // 神策地址
  SHENCELINK?: string;
  // 活体认证地址
  THINKIVEIDENTIFICATION?: string;
  // 在线客服地址
  ONLINEKF: string;
  // 0或者空表示使用老资管服务，1表示使用资管线上化重构功能
  ASSETMANAGEMENTFUNDKEY: string;
};

const commonConfigCacheStorage = new LocalCacheStorage<unknown>(
  crabDevice.isTZT ? new AppCache('__LC_MALL_COMMON_CONFIG') : new SessionStorageCache('__LC_MALL_COMMON_CONFIG')
);

const CACHE_KEY = 'COMMON_CONFIG';
const DEFAULT_ERROR_MSG = '接口初始化失败';
let commonConfig: CommonConfig | null = null;

const getCommonConfigMutex = new Mutex();
/**
 * 获取配置接口参数
 * @returns
 */
export async function getCommonConfig(): Promise<CommonConfig> {
  await getCommonConfigMutex.acquire();
  // 读取内存数据
  if (commonConfig) {
    getCommonConfigMutex.release();
    return commonConfig;
  }

  // 读取本地缓存
  const config = await commonConfigCacheStorage.getCache<CommonConfig>(CACHE_KEY);
  if (config) {
    commonConfig = config;
    getCommonConfigMutex.release();
    return commonConfig;
  }

  // 读取接口配置
  try {
    const res = await xfnRequest.getXfnData(
      {
        ACTION: '46200',
        REQLINKTYPE: '2',
      },
      { autoLoading: false }
    );
    if (!res.FUNDLINK) {
      // eslint-disable-next-line no-throw-literal
      throw {
        ERRORMESSAGE: DEFAULT_ERROR_MSG,
      };
    }
    commonConfig = {
      FUNDLINK: res.FUNDLINK,
      SHENCELINK: res.SHENCELINK,
      THINKIVEIDENTIFICATION: res.THINKIVEIDENTIFICATION,
      ONLINEKF: res.ONLINEKF,
      ASSETMANAGEMENTFUNDKEY: res.ASSETMANAGEMENTFUNDKEY,
    };
    commonConfigCacheStorage.setCache(CACHE_KEY, commonConfig);
    getCommonConfigMutex.release();
    return commonConfig;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    getCommonConfigMutex.release();
    // eslint-disable-next-line no-throw-literal
    throw {
      code: -1,
      message: error.ERRORMESSAGE || DEFAULT_ERROR_MSG,
    };
  }
}
